// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"5b6f72a3","535":"6630ee56","693":"038cf65d"}[chunkId] + ".chunk.js";
};